import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  useToast,
  FormControl,
} from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import UserApi from 'api/user';
import { useAuth } from '../../../../auth-context/auth.context';
import InputField from 'components/formComponents/inputField';
import SelectField from 'components/formComponents/selectField';
import { AdminUserFormValidationSchema } from 'formValidations/adminUserFormValidations';

export default function PopModal(props) {
  const { user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const toast = useToast();

  const initialValues = {
    name: '',
    email: '',
    phoneNumber: '',
    userType: '',
    status: '',
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const api = await UserApi.Create(values);
      if (api.data.status_code === 200) {
        toast({
          title: api?.data?.message || 'Successfully Added',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        props.func();
      } else {
        toast({
          title: api?.data?.message,
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button
        variant='lightBrand'
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        boxShadow='lg'
        px='15px'
        py='5px'
        onClick={onOpen}>
        {props.Icon}
      </Button>

      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Formik
              initialValues={initialValues}
              validationSchema={AdminUserFormValidationSchema}
              onSubmit={handleSubmit}>
              {({ isSubmitting }) => (
                <Form noValidate>
                  <InputField
                    label='Name'
                    name='name'
                    placeholder='Name'
                    required
                  />
                  <InputField
                    label='Email'
                    name='email'
                    type='email'
                    placeholder='Enter Email'
                    required
                  />
                  <InputField
                    label='Phone Number'
                    name='phoneNumber'
                    type='number'
                    placeholder='Phone Number'
                    required
                  />
                  <SelectField
                    label='User Type'
                    name='userType'
                    placeholder='Select option'
                    options={[
                      { value: 'ADMIN', label: 'Admin' },
                      { value: 'SHOWROOM', label: 'Showroom' },
                    ]}
                    required
                  />
                  <SelectField
                    label='Status'
                    name='status'
                    placeholder='Select option'
                    options={[
                      { value: 'ACTIVE', label: 'Active' },
                      { value: 'INACTIVE', label: 'Inactive' },
                      { value: 'UNVERIFIED', label: 'Unverified' },
                      { value: 'BLOCKED', label: 'Blocked' },
                    ]}
                    required
                  />
                  <ModalFooter>
                    <Button
                      colorScheme='blue'
                      mr={3}
                      type='submit'
                      isLoading={isSubmitting}>
                      Save
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
